import axios from "axios";
import router from "@/router";
import { Message } from 'element-ui';

// 配置基础URL
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://www.stzhaiquan.com/api/pc/'

// 配置全局超时时间
axios.defaults.timeout = 10000

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const token = localStorage.getItem("token");
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwd2QiOiJkNDFkOGNkOThmMDBiMjA0ZTk4MDA5OThlY2Y4NDI3ZSIsImlzcyI6Ind3dy5zdHpoYWlxdWFuLmNvbSIsImF1ZCI6Ind3dy5zdHpoYWlxdWFuLmNvbSIsImlhdCI6MTc4Mjc4MzEzNSwibmJmIjoxNzgyNzgzMTM1LCJleHAiOjE3ODUzNzUxMzUsImp0aSI6eyJpZCI6MTAsInR5cGUiOiJhcGkifX0.1hyWZxKxU8oHHjiYYIH2VulCj4FHmZrL2RlgkKyiASI'
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 处理业务状态码
    const data = response.data;
    
    // 统一处理 status !== 200 的情况
    if (data.status !== undefined && data.status !== 200) {
      // 特殊处理 110002 未登录
      if (data.status === 110002) {
        localStorage.removeItem('token');
        router.push({ path: "/login" });
        Message.error('登录已过期，请重新登录');
      }else if (data.status === 310002) {
        router.push({ path: "/register" });
        Message.error('请先注册');
      }else {
        // 其他错误码统一提示错误消息
        const errorMsg = data.message || data.msg || '请求失败';
        Message.error(errorMsg);
      }
      
      // 返回 resolved 的 Promise，避免页面报错
      return Promise.resolve({ status: 0, data: null });
    }
    
    return data;
  },
  function (error) {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 400:
          // 400 错误提示报错信息
          const errorMsg = error.response.data.message || error.response.data.msg || '请求参数错误';
          Message.error(errorMsg);
          break;
        case 401:
          localStorage.removeItem('token');
          router.push({ path: "/login" });
          Message.error('登录已过期，请重新登录');
          break;
        case 403:
          Message.error('没有权限访问');
          break;
        case 404:
          Message.error('请求的资源不存在');
          break;
        case 500:
          Message.error('服务器错误');
          break;
        default:
          Message.error(error.response.data.message || error.response.data.msg || '请求失败');
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      Message.error('网络异常，请检查网络连接');
    } else {
      // 其他错误
      Message.error(error.message || '请求失败');
    }
    // 返回一个 resolved 的 Promise，避免页面报错
    return Promise.resolve({ status: 0, data: null });
  }
);
// ==================== 登录相关接口 ====================

//获取appid
export function getAppid() {
  return axios.get(`/get_appid`);
}
// 根据code获取token
export function getLoginToken(params) {
  return axios.get(`wechat_auth`,{params});
}

// ==================== 注册相关接口 ====================

// 获取验证码
export function getCode(data) {
  return axios.post(`send_sms_code`,data);
}
// 用户注册
export function postRegisterInfo(data) {
  return axios.post(`user/reg`,data);
}
/**
 * @description 图片上传
 */
export function fileUpload(data) {
  return axios.post(`upload`,data);
}

// ==================== 首页相关接口 ====================

// 首页数据
export function getIndex() {
  return axios.get(`home/index`);
}
// ==================== 常见问题相关 ====================
// 获取常见问题
export function getFaqList(params) {
  return axios.get(`faq/lists`, { params });
}
// 获取常见问题分类
export function getFaqTypeList() {
  return axios.get(`faq/category/lists`);
}
// 获取常见问题详情
export function getFaqDetail(id) {
  return axios.get(`faq/detail/${id}`);
}
// ==================== 代写文书相关 ====================
// 代写信息提交
export function postDocOrder(data) {
  return axios.post(`document/order_create`, data);
}
// 获取代写分类
export function getDocTypeList() {
  return axios.get(`document/service_list`);
}
// ==================== 广场/筛选相关接口 ====================

// 获取广场债权债务列表
export function getSquareList(data) {
  return axios.post(`debt/lists`, data);
}
// 获取债权债务详情
export function getSquareDetail(id) {
  return axios.get(`debt/detail/${id}`);
}

// 获取筛选选项
export function getFilterOptions() {
  return axios.get(`debt/search_options`);
}

// 获取推荐列表
export function getEliteList(params) {
  return axios.get(`debt/elite`,{params});
}
// 收藏信息
export function getFavorited(data) {
  return axios.post(`debt/collect`,data);
}
// 取消收藏
export function cancleFavorited(data) {
 return axios.post(`debt/uncollect`,data);
}

// ==================== 债权/债务相关接口 ====================

// 发布债权债务
export function postPublish(data) {
  return axios.post(`debt/publish`, data);
}
// 获取债权债务分类
export function getPublishTypeList(params) {
  return axios.get(`debt/type`,{params});
}
// 获取省市区
export function getAreaList() {
  return axios.get(`city_list`);
}

// ==================== 搜索相关接口 ====================

// 获取搜索结果列表
export function getSearchList(params) {
  return axios.get(`search`, {params});
}


// ==================== 协议相关接口 ====================

export function getAgreement(id) {
  return axios.get(`get_agreement/${id}`);
}


// ==================== 个人中心相关接口 ====================

//获取我的收藏列表
export function getMyFavoritesList(params) {
  return axios.get(`user/my_collect`,{params});
}
//获取我的代写文书列表
export function getMyLegalDocsList(params) {
  return axios.get(`document/order_list`,{params});
}
//获取我的订单列表
export function getMyOrderList(params) {
  return axios.get(`order/list`,{params});
}
//获取我的订单详情
export function getMyOrderDetail(id) {
  return axios.get(`order/detail/${id}`);
}
//获取订单类型
export function getOrderType() {
  return axios.get(`order/options`);
}
//获取我的债务列表
export function getMyDebtList(params) {
  return axios.get(`user/my_debt`,{params});
}
//获取我的债务详情
export function getMyDebtDetail(params) {
  return axios.get(`user/debt_detail`,{params});
}
//获取我的债权列表
export function getMyClaimList(params) {
  return axios.get(`user/my_creditor`,{params});
}
//获取我的债权列表统计
export function getMyClaimTop() {
  return axios.get(`user/my_creditor_count`);
}
//获取我的债权详情
export function getMyClaimDetail(params) {
  return axios.get(`user/creditor_detail`,{params});
}
//信息下线
export function getInfoUnline(data) {
  return axios.post(`user/debt_offline`,data);
}
//信息上线
export function getInfoOnline(data) {
  return axios.post(`user/debt_online`,data);
}
//信息删除
export function getInfoDelete(data) {
  return axios.post(`user/debt_delete`,data);
}
//信息标记已解决
export function getInfoFinished(data) {
  return axios.post(`user/debt_complete`,data);
}
//信息编辑获取详情
export function getInfoDetail(params) {
  return axios.get(`user/debt_info`,{params});
}
//信息编辑提交
export function getInfoEdit(data) {
  return axios.post(`user/debt_edit`,data);
}
//购买展示天数
export function payShowDays(data) {
  return axios.post(`order/create_info_display`,data);
}
//购买展示天数的基本配置信息
export function getCommonPayConfig() {
  return axios.get(`pay_config`);
}
//申请退款类型
export function getBackMoneyType() {
  return axios.get(`after_sale/types`);
}
//申请退款
export function applyBackMoney(data) {
  return axios.post(`after_sale/apply`,data);
}
//获取个人资料
export function getUserInfo() {
  return axios.get(`user/info`);
}
//修改个人资料
export function updateUserInfo(data) {
  return axios.post(`user/update_info`,data);
}
//修改头像
export function updateUserAvatar(data) {
  return axios.post(`user/up_nick_avatar`,data);
}
//退出登录
export function getLogOut() {
  return axios.get(`user/logout`);
}

// ==================== 支付相关 ====================
//购买机密信息
export function payInfomation(data) {
  return axios.post(`order/create_info_show`,data);
}
//支付评估费
export function getOrderPay(id) {
  return axios.get(`order/pay_ewm/${id}`);
}

// ==================== 联系我们 ====================
//获取联系我们方式
export function getCommonInfo() {
  return axios.get(`contact_us`);
}
//提交留言
export function submitMessage(data) {
  return axios.post(`message/submit`,data);
}
//检查注册状态
export function checkRegisterStatus() {
  return axios.get(`user/check_reg`);
}






export default axios;
